module.exports = __webpack_public_path__ + "img/sv83.7a61eeaf.svg";